import React from 'react';
import { entrarConPin } from '../../lib/pinSession';
import TecladoPin from '../../components/ui/TecladoPin';
import SyncIndicator from '../../components/SyncIndicator';
import { EncabezadoIngresoPin } from '../../components/EncabezadoApp';

// Pantalla de ingreso con PIN (PIN central, etapa 2, 2026-10-21). El teclado es el TecladoPin común de
// shared/vls-ui: el PIN vive solo en su estado (sin <input>, sin storage, sin URL), bloqueo por hora límite,
// teclado físico acotado a la pantalla y "Verificando…" en una región viva. La validación es la de siempre
// (/api/pin-session), que ahora pasa por la central (cables_verificar_pin envuelve a acc_pin_verificar).
// 4 a 8 dígitos con Entrar: los PINs nuevos son de 4, los que ya existen se respetan.
export default function PinPantalla({ onAdmin }) {
  // Encabezado común de VLS arriba (EncabezadoIngresoPin: logo, nombre y reloj, sin menú ni Salir).
  return (
    <>
      <EncabezadoIngresoPin />
      <main className="flex min-h-[calc(100dvh-64px)] flex-col items-center bg-background px-5 pt-6 pb-safe text-foreground">
        <div className="flex w-full max-w-sm flex-1 flex-col items-center justify-between gap-4">
          {/* Tras "Salir" el teléfono puede guardar inspecciones sin enviar: sin
              sesión no se pueden mandar, pero tienen que verse. */}
          <div className="w-full empty:hidden">
            <SyncIndicator puedeEnviar={false} ayuda="Entre con su PIN para enviarlas." />
          </div>

          <TecladoPin
            largo={null}
            min={4}
            max={8}
            titulo="Inspección diaria"
            subtitulo="Ingrese su PIN"
            tamano="normal"
            onEnviar={(pin) => entrarConPin(pin)}
          />

          <button
            type="button"
            onClick={() => onAdmin?.()}
            className="min-h-[48px] px-3 text-sm text-muted-foreground underline"
          >
            Soy de administración: iniciar sesión
          </button>
        </div>
      </main>
    </>
  );
}
